// extracted by mini-css-extract-plugin
export default {"searchGroupWrap":"searchGroupWrap---bf1LY","filtersLabel":"filtersLabel---LSpYt"};